// extracted by mini-css-extract-plugin
export default {"login_btn":"Login_login_btn__3XsXq","login_card":"Login_login_card__psrni"};